import React, { Component } from 'react';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import AddCancelReasonForm from '../../../components/SiteAdmin/AddCancelReasonForm';


export class AddCancelReason extends Component {

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <AddCancelReasonForm />
    )
  }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(AddCancelReason)
